export const svCompareString = (a, b) => {
  const svOrder = ['å', 'ä', 'ö']
  const aLowered = a.toLowerCase().replace(/\s/g, '')
  const bLowered = b.toLowerCase().replace(/\s/g, '')
  let aChar
  let bChar
  let index

  for (index = 0; index < aLowered.length; index += 1) {
    aChar = aLowered[index]
    bChar = bLowered[index]
    // There's more characters in a than b
    if (!bChar) {
      return 1
    }
    if (aChar !== bChar) {
      if (svOrder.indexOf(aChar) !== -1 || svOrder.indexOf(bChar) !== -1) {
        if (svOrder.indexOf(aChar) > svOrder.indexOf(bChar)) {
          return 1
        }
      } else if (aChar > bChar) {
        return 1
      }
      return -1
    }
  }
  // There's more characters in b than a
  if (bLowered.length > index) {
    return -1
  }
  return 0
}
